// src/core/utils/LoadingContext.js
import React, { createContext, useContext, useState } from "react";

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const show = (msg) => {
        setMessage(msg || "Cargando...");
        setLoading(true);
    };

    const hide = () => {
        setLoading(false);
        setMessage("");
    };

    return (
        <LoadingContext.Provider value={{ loading, message, show, hide }}>
            {children}
        </LoadingContext.Provider>
    );
};

// Hook helper correcto
export const useLoading = () => useContext(LoadingContext);
